import React from "react";
import { combinePath } from "brew-js/util/path";
import { ValidateResult } from "zeta-dom-react";
import { any, noop, pipe } from "zeta-dom/util";
import type { ApiResult } from "src/api";
import { CLASSIC_EAC_URL, PUBLIC_URL } from "src/config/env";
import { Link } from "src/api/types";
import Bus from 'src/util/eventBus'
import { app } from "src/core/app";
import $ from "jquery";
import waterpipe from "waterpipe";

export function assign<T extends object>(obj: T, ...props: Partial<T>[]): T {
    return Object.assign(obj, ...props);
}

export function mapLabelValue<T extends object>(dict: T, getLabel: (key: keyof T) => string) {
    return (Object.keys(dict) as (keyof T)[]).map(v => {
        return {
            value: dict[v] as Zeta.ValueOf<T>,
            get label() {
                return getLabel(v);
            }
        };
    });
}

export function linkAttr(url: string, target?: React.HTMLAttributeAnchorTarget): Pick<React.ComponentPropsWithRef<'a'>, 'href' | 'target' | 'rel'> {
    url = url || '';
    if (target === '_blank' || (!target && (url.indexOf('://') > 0 || url.indexOf('/redirect/') > 0))) {
        return { href: url, target: '_blank', rel: 'noreferrer' };
    } else {
        return { href: url };
    }
}

export function backgroundImage(url: string) {
    if (url) {
        return {
            backgroundImage: `url('${url}')`
        };
    }
}

export function hasRepeatingChar(value: string, count: number) {
    let prev = value[0];
    let acc = 1;
    for (let i = 1, len = value.length; i < len; i++) {
        acc = value[i] === prev ? acc + 1 : 1;
        if (acc === count) {
            return true;
        }
        prev = value[i];
    }
}

export function isValidationFailed<T extends Record<keyof T, ValidateResult>>(result: T) {
    if (Object.values(result).some(v => v)) {
        return result;
    }
}

export function parseDuration(value: string, unit: 's' | 'ms' = 'ms') {
    let map = { d: 86400, h: 3600, m: 60, s: 1 };
    let duration = 0;
    for (let [, a, b] of value.matchAll(/(\d+)([dhms])/g)) {
        duration += map[b as keyof typeof map] * +a;
    }
    return duration * (unit === 'ms' ? 1000 : 1);
}

export function parseJWT(token: string) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
        return JSON.parse(jsonPayload);
    } catch { }
}

export function createAsyncQueue() {
    let lastPromise: Promise<any>;
    return async <T>(promise: () => Promise<T>) => {
        while (lastPromise) {
            let current = lastPromise;
            await current;
            // check if this invocation is the first being queued on the promise
            // to ensure each run is in sequence
            if (lastPromise === current) {
                break;
            }
        }
        lastPromise = promise();
        return lastPromise;
    };
}

export function openWindow(url: string) {
    window.open(url, '', 'noreferrer');
}

export async function openDeferredLink(promise: ApiResult<string>) {
    const frame = window.open(combinePath(PUBLIC_URL, '/blank.html'));
    if (!frame) {
        throw new Error();
    }
    Promise.resolve(promise).catch(() => {
        frame.close();
    });
    let url = await promise;
    frame.location.replace(url);
}

export function getValueOrDefault<T>(...args: (T | undefined)[]): T {
    if (args.length === 2) {
        let [a, b] = args;
        return a || b as T;
    }
    return any(args, pipe) || args.pop() as T;
}

export function iff<T extends ([() => any] | [() => any, () => any])>(condition: any, ...args: T): T extends ([() => infer U, () => infer V]) ? U | V : ReturnType<T[0]> | undefined {
    let [thenFn, elseFn] = args;
    return condition ? thenFn() : (elseFn || noop)() as any;
}

export const handleDoubleClick = (e: any, url: string) => {
    const target = e.currentTarget.getAttribute('target');
    const appid = app.auth.ssoAppId.toLowerCase();
    const appidFlag = (appid === "ieng" || appid === "imo");
    if ((appidFlag && url.includes("/redirect")) || (target !== "_blank" && url.includes("/redirect"))) {
        e.preventDefault();
        const requestURL: any = url.split("/").pop();
        const params = Object.fromEntries(new URLSearchParams(url.split('?')[1]).entries());
        const param = {
            action: combinePath(CLASSIC_EAC_URL, '/ssoMode.do'),
            token: app.auth.accessToken,
            lang: app.language === 'en' ? 'en' : 'zh',
            cloudURL: app.previousPath || app.route.getPath({ language: app.language }),
            requestURL: requestURL,
            params: params && JSON.stringify(params)
        };

        const form = $(waterpipe(`
        <form method="post" action="{{action}}" style="position:fixed;top:-10px;left;-10px">
            <input type="hidden" name="lang" value="{{lang}}" />
            <input type="hidden" name="requestURL" value="{{requestURL}}" />
            <input type="hidden" name="cloudURL" value="{{cloudURL}}" />
            <input type="hidden" name="params" value="{{params}}" />
            <input type="hidden" name="authorization" value="Bearer {{token}}" />
        </form>`, param)).appendTo(document.body)[0] as HTMLFormElement;
        form.submit();
    }
}

export const handleBlueCross = (e: any, item: Link) => {
    if (item.id === "aia-blue-cross-insurance-company") {
        e.preventDefault();
        Bus.emit("blueCrossOpen", item.url);
    }
    handleDoubleClick(e, item.url);
}
